// @flow
import React from 'react';
import {Link} from 'react-router-dom';

export type Props = {
  project: Object,
  apartment: Object,
  user: Object,
};

const OrderRelationLinks = ({project, apartment, user}: Props) => (
  <div className="OrderRelationLinks row">
    <div className="column">
      <label>
        Projekt
      </label>
      <Link
        className="entity-item"
        to={`/projects/${project.id}`}>
        {project.name}
      </Link>
    </div>
    <div className="column">
      <label>
        Lägenhet
      </label>
      <Link
        className="entity-item"
        to={`/apartments/${apartment.id}`}>
        {apartment.objectId}
      </Link>
    </div>
    <div className="column">
      <label>
        Kund
      </label>
      <Link
        className="entity-item"
        to={`/users/${user.id}`}>
        {user.person.name}
      </Link>
    </div>
  </div>
);

export default OrderRelationLinks;



// WEBPACK FOOTER //
// ./src/components/OrderRelationLinks/OrderRelationLinks.js